'use client';

import { ErrorBoundary } from '@/shared/ui/error-boundary';
import { useModalsStore } from './store';

/** Renders all modals above each other */
export const ModalContainer = () => {
    const data = useModalsStore((s) => s.data);
    const hide = useModalsStore((s) => s.hide);

    return Object.entries(data).map(([id, { Component, componentProps, isClosing }]) => (
        // Isolate each modal: a crash in one renders nothing (and is reported to Sentry)
        // instead of bubbling to the route boundary and blanking the whole page behind it.
        <ErrorBoundary key={id} sentryTags={{ area: 'modal', modalId: id }} fallback={() => null}>
            <Component
                modalId={parseInt(id)}
                // "_" is here to make the props same as in ModalProps & useModalContext
                onClose={(_?: unknown, skipCloseGuardCheck?: boolean) =>
                    hide(parseInt(id), skipCloseGuardCheck)
                }
                isClosing={isClosing}
                {...componentProps}
            />
        </ErrorBoundary>
    ));
};
